import { ChangeDetectionStrategy, Component, computed, inject, input, OnInit, output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateFilterFn } from '@angular/material/datepicker';

import { Tools } from '../../../core/utils/tools';
import { TranslationService } from '../../../services/translation.service';
import { DatepickerDateAdapter } from './datepicker-date-adapter';

@Component({
    selector: 'sl-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'de' },
        { provide: DateAdapter, useClass: DatepickerDateAdapter },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: { dateInput: { day: 'numeric', month: 'numeric', year: 'numeric' } },
                display: {
                    dateInput: 'input',
                    monthYearLabel: { month: 'short', year: 'numeric' },
                    dateA11yLabel: 'input',
                    monthYearA11yLabel: { month: 'short', year: 'numeric' }
                }
            }
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DatepickerComponent implements OnInit {
    // eslint-disable-next-line @angular-eslint/no-output-native
    readonly blur = output<void>();
    // eslint-disable-next-line @angular-eslint/no-output-native
    readonly input = output<any>();

    readonly control = input.required<AbstractControl>();
    readonly placeholderKey = input<string>();
    readonly isDisabled = input(false);
    readonly tagId = input<string>();
    readonly customStyle = input<object>();
    readonly datePickerFilter = input<DateFilterFn<any>>(() => true);

    readonly id = computed(() => this.tagId() ?? Tools.Utils.newGuid());

    private readonly _adapter = inject(DateAdapter<any>);
    private readonly translationService = inject(TranslationService);

    ngOnInit(): void {
        this._adapter.setLocale(this.translationService.getCurrent().code);
    }

    onBlur(): void {
        this.blur.emit();
    }

    onInput(event: any): void {
        this.input.emit(event);
    }

    getHintText(): string {
        return this.translationService.getCurrent().code === 'en' ? 'MM/DD/YYYY' : 'DD.MM.YYYY';
    }
}
